import { LoadingOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Input, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";
import CreateTaskApi from "../../../api/tasks/CreateTaskApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

function AddTaskModal(props) {
  const [form] = Form.useForm();
  const [submit, setSubmit] = useState(false);

  function handleCancel() {
    form.resetFields();
    props.handleCancel();
  }
  async function onFinish(values) {
    setSubmit(true);
    const apiResponse = await CreateTaskApi(
      props.planId,
      values.name,
      values.targetDate
    );

    if (apiResponse.statusCode) {
      openNotificationError(
        "bottomRight",
        "Couldn't add task. Try again later."
      );
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "Task added successfully");

      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add task. Try again later."
      );
    }
    handleCancel();
    setSubmit(false);
  }

  return (
    <Modal
      title="Add Task"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="addTask"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
        form={form}
      >
        <Form.Item
          label="Task*"
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter a Task!",
            },
          ]}
        >
          <Input placeholder="Task name" />
        </Form.Item>
        <Form.Item
          label="Target date*"
          name="targetDate"
          rules={[
            {
              required: true,
              message: "Please enter target date!",
            },
          ]}
        >
          <DatePicker className="w-full" />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                `Add`
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddTaskModal;
